import { useEffect, useState } from 'react'
import CreationToolCrop from '../types/crop'

/**
 * Returns the creation crop type based on dimensions.
 */
export function useCreationCropType(width: number, height: number, originalAspectRatio: number = 0): CreationToolCrop {
    const [cropType, setCropType] = useState<CreationToolCrop>(CreationToolCrop.Custom)

    useEffect(() => {
        const aspectRatio = width / height

        if (originalAspectRatio === aspectRatio) {
            setCropType(CreationToolCrop.Original)
        } else {
            const cropTypeMatch = CreationToolCrop.all().find(
                (type) => CreationToolCrop.aspectRatio(type) === aspectRatio
            )
            setCropType(cropTypeMatch || CreationToolCrop.Custom)
        }
    }, [width, height, originalAspectRatio, setCropType])

    return cropType
}
